module.exports = __webpack_public_path__ + "static/media/loading.a7bad1af.gif";